<template>
  <svg v-if="props.type=='fill'" :fill="color" @mouseover="mouseover" @mouseout="mouseout">
    <use :xlink:href="`#icon-${icon}`" :fill="color" />
  </svg>
  <svg v-else-if="props.type=='stroke'" :stroke="color" @mouseover="mouseover" @mouseout="mouseout">
    <use :xlink:href="`#icon-${icon}`" :stroke="color" />
  </svg>
  <svg v-else :style="style">
    <use :xlink:href="`#icon-${icon}`" />
  </svg>
</template>

<script lang="ts" setup>
const props = defineProps({
  icon: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: 'currentColor'
  },
  hoverColor: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  },
  size: {
    type: Number,
    default: 0
  }
});

const color = ref<string>(props.color);

const mouseover = () => {
  if (props.hoverColor) {
    color.value = props.hoverColor;
  }
};

const mouseout = () => {
  if (props.hoverColor) {
    color.value = props.color;
  }
};

const style = computed(() => {
  if (props.size > 0) {
    return {
      width: `${props.size}px`,
      height: `${props.size}px`
    };
  } else {
    return {};
  }
});

</script>

<style lang="scss" scoped>
svg {
  outline: none;
  transition: all .5s ease
}
</style>
